<template>
    <div class="main_component_container filters" :key="App.query.query_count">
        <comp_modal_conflict_filters></comp_modal_conflict_filters>

        <section class="flexbox_container full_height">
            <!-- Parameters list -->
            <div class="box col1">
                <header>
                    <h2 class="title">
                        {{ translations.query_filters.title }}
                    </h2>
                    <h3 v-if="App.query.current_query" class="subtitle">
                        <span class="query_info_title">&#151; {{ translations.generic.query }}</span>
                        {{ App.query.current_query.name }}
                    </h3>
                    <h3 v-else class="subtitle">
                        {{ translations.query_filters.subtitle }}
                    </h3>
                </header>

                <!-- TABS parametros/detalles -->
                <nav class="query_panel_tabs">
                    <p :class="{ selected: current_tab == 'category_filters' }" @click="current_tab = 'category_filters'">
                        {{ translations.query_filters.query_params }}
                    </p>
                    <p :class="{ selected: current_tab == 'detail_filters' }" @click="current_tab = 'detail_filters'">
                        {{ translations.query_filters.query_details }}
                    </p>
                </nav>
                <section>
                    <!-- TAB: parametros -->
                    <span v-if="current_tab === 'category_filters'" class="category_filters">
                        <p class="filter_panel box_filter" :class="{
                            is_current_category_filter: key == current_category_filter_selected
                        }" @click="selectFilterGroup(key)" v-for="(value, key) in App.query.active_filters" :key="key">
                            <span class="filter_category">
                                {{ App.translations.categories[key][App.selected_language] }}
                            </span>
                            <span class="number_item_filter" v-if="App.query.getTotalSelectedForFilterGroup(key) > 0">
                                {{ App.query.getTotalSelectedForFilterGroup(key) }}
                            </span>
                        </p>
                    </span>

                    <!-- TODO: TAB: detalles -->
                    <div v-if="current_tab === 'detail_filters'" class="detail_filters">
                        <section v-if="true && App.query.getTotalSelected() > 0" class="filters_selected">
                            <ul class="detail_panel" v-for="(values, key) in App.query.getFilters()" :key="key">
                                <li v-if="key != 'language' && key != 'market' && values.length > 0">
                                    <label>{{
                                        App.translations.categories[
                                            App.query.valid_keys[key]
                                        ][App.selected_language]
                                    }}</label>
                                    <ul>
                                        <li v-for="(filter, index) in values" :key="index">
                                            {{ App.entities[App.query.valid_keys[key]][filter][App.selected_language] }}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </section>
                        <section v-else class="content">
                            <p>
                                {{
                                    translations.query_filters
                                        .no_params_selected
                                }}
                            </p>
                            <button class="button-previous-page" @click="toggleMenu('category_filters')">
                                <i class="shadow_box icon-chevron-left"></i><span>{{
                                    translations.query_filters.go_to_params
                                }}</span>
                            </button>
                        </section>
                    </div>
                </section>

                <!-- LIMPIAR CONSULTA -->
                <div class="content_button">
                    <div v-if="App.query.getTotalSelected() > 0" @click="App.query.clean()" class="button black30">
                        <i class="icon-close"></i>
                        <span class="uppercase">{{
                            translations.query_filters.clean_query
                        }}</span>
                    </div>
                </div>
            </div>

            <!-- Parameter values -->
            <div class="box col2">
                <!-- SIN CATEGORIA SELECCIONADA  -->
                <span v-if="!current_category_filter_selected" class="clean_filters_params">
                    <nav class="queries_panel_menu_options is_clean_filter_panel_menu">
                        <div @click="openSavedQueriesModal" v-show="false" class="button black30 uppercase">
                            <i class="icon-saved-queries"></i>{{ translations.query_nav_options.saved_queries }}
                        </div>
                    </nav>
                    <img src="img/logo_unex_negative.svg" style="max-width:125px" />
                </span>

                <!-- CON CATEGORIA SELECCIONADA -->
                <div v-if="current_category_filter_selected">
                    <header>
                        <comp_query_nav_options></comp_query_nav_options>
                        <h2 class="title capitalize">
                            {{
                                App.translations.categories[
                                current_category_filter_selected
                                ][App.selected_language]
                            }}
                        </h2>
                        <h3 class="results">
                            <span>{{ App.query.getTotalSelectedForFilterGroup(current_category_filter_selected) }}
                                {{ translations.query_filters.result_text_of }}
                                {{ App.query.getTotalForFilterGroup(current_category_filter_selected) }}</span>
                            {{ translations.query_filters.result_text_info }}
                        </h3>
                    </header>
                    <section>
                        <!-- TODO ,
                                hide_filter: !filter.possible,
                                disable_filter: !filter.has_results
                                -->
                        <p v-bind:class="{
                            selected_filter: filter.selected,
                            disable_filter: !filter.has_results
                        }" @click="addFilter(filter)" class="box_filter_item"
                            v-for="(filter, index) in App.query.active_filters[current_category_filter_selected]"
                            :key="index">
                            {{ filter.text }}
                        </p>
                    </section>
                    <footer v-if="App.query.getTotalSelected() > 0">
                        <span class="prev_results">({{ App.query.total_works }} | {{ App.query.total_solutions }})</span>
                        <div @click="queryApply" class="button launch_query">
                            <img src="svg/search_check.svg" />{{
                                translations.generic.apply
                            }}
                        </div>
                    </footer>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import App from './../application.js'
import comp_modal_conflict_filters from './comp_modal_conflict_filters.vue'
import comp_query_nav_options from './comp_query_nav_options.vue'

export default {
    components: {
        comp_modal_conflict_filters,
        comp_query_nav_options
    },
    data: function () {
        return {
            App: App,
            current_tab: 'category_filters',
            translations: {
                query_filters: App.current_translations['query_filters'],
                generic: App.current_translations['generic'],
                categories: App.current_translations['categories'],
                query_nav_options: App.current_translations['query_nav_options']
            },

            current_category_filter_selected: null,
        };
    },
    mounted: function () {
        var self = this;

        // App.bus.$on('is_back_to_filter_view', function () {
        //     App.current_category_filter_selected =
        //         Object.keys(App.unex_lib.active_filters)[
        //         App.query.getSelectedFilters(App.unex_lib.active_filters).findIndex(function (element, index) {
        //             if (element.length > 0) return true;
        //         })
        //         ];
        // });
        App.bus.$on('saveChangeMarketApp', function () {
            self.resetFilters();
            self.query_loaded = {};
        });
        App.bus.$on('saveChangeLanguageApp', function () {
            self.resetFilters();
        });

        // TODO: posar a la classe Query
        // App.bus.$on('refreshFilters', function (filters) {
        //     self.resetFilters(App.getFilters({}, this));
        //     App.bus.$emit('hide_loader', 'filters');
        // });

        // TODO: carregar query guardada
        App.bus.$on('load_query', function (query) {
            console.warn(query);
            query.data['market'] = query.id_market;
            self.resetFilters(query.data, query);

            App.bus.$emit("on_selected_item", App.getTotalFiltersSelected(self.filters_selected));
            App.bus.$emit('hide_loader', 'filters');
        });
        App.bus.$on('launch_query', function (query) {
            console.warn(query);
            App.query.loadSavedQuery(query);
            return;
            // query.data['market'] = query.id_market;
            // self.resetFilters(query.data, query);
            // App.bus.$emit("on_selected_item", App.getTotalFiltersSelected(self.filters_selected));
            // self.queryApply();
            // App.bus.$emit('hide_loader', 'filters');
        });

        document.title = "UnexApp - " + App.current_translations.details_query.title
    },
    methods: {
        resetFilters: function (filters_selected, query_loaded) {
            // TODO: ?
            return;
        },

        /**
         * Activar un grupo de filtros
         */
        selectFilterGroup: function (filter, message) {
            this.current_category_filter_selected = filter;

            return;
        },
        addFilter: async function (filter) {
            if (!filter.has_results) return;

            filter.selected = !filter.selected;

            // App.showSpinner();
            await App.query.runFiltersQuery(
                App.query.getFilters(filter, this)
            );
            // App.hideSpinner();
        },
        queryApply: async function () {
            // TODO: refactor fora d'aqui i tenir en compte queryloaded
            // var search_results = null;
            // if (Object.keys(this.query_loaded).length !== 0) {
            //     search_results = await App.query.runSolutionsQuery(
            //         App.query.getFilters(null, this, '', this.query_loaded)
            //     );
            // } else {
            //     search_results = await App.query.runSolutionsQuery(
            //         App.query.getFilters(null, this)
            //     );
            // }

            App.showSpinner();
            await App.query.runSolutionsQuery(
                App.query.getFilters(null, this)
            );
            App.hideSpinner();

            // this.$root.$data.list_order_field = 'year';
            // this.$root.$data.list_order_direction = 'DESC';

            this.$router.push('/solutions');
        },
        openSavedQueriesModal: function (tab) {
            App.bus.$emit('modal_saved_queries', tab);
        },

    }
}
</script>

<style></style>